"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectGroupById = void 0;
const reselect_1 = require("reselect");
const groups_1 = require("./groups");
exports.selectGroupById = (0, reselect_1.createSelector)([groups_1.getUserGroups, (state, groupId) => groupId], (groups, groupId) => {
    return groups.find(group => group.identifier === groupId);
});
